export const DEFAULT_TIME_LOADING = 30000;

export const USER_EVENT = [
    "load",
    "mousemove",
    "mousedown",
    "click",
    "scroll",
    "keypress"
]
export const TIME_LOGOUT = 50000;
